import React from 'react';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import CIPRegisterAddEdit from './cip-register-add-edit';

const { CIPREGISTER_ADD_EDIT } = MODAL_TYPES;

const CipRegisterModals = () => {
  return (
    <>
      <CIPRegisterAddEdit modalId={CIPREGISTER_ADD_EDIT} />
    </>
  );
};

export default CipRegisterModals;
